<template>
  <div>
    <v-dialog v-model="value" persistent max-width="1000px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 :key="key">
                <b
                  v-if="imageData !== ''"
                  style="font-size: 18px"
                  :class="[
                    imageWidth < 800 ? 'error--text' : 'success--text',
                    'font-weight-bold',
                  ]"
                >
                  La imagen que intentas subir, tiene un ancho de
                  {{ imageWidth }}px, te recomendamos que tenga al menos un
                  ancho de 800 px.
                </b>
                <div v-if="imageData === ''" class="upload">
                  <div class="icon-box">
                    <span class="subheading font-weight-medium">
                      Cargar imagen
                    </span>
                    <v-icon color="primary">upload</v-icon>
                  </div>
                  <input
                    type="file"
                    accept="image/jpeg, image/png"
                    @change="onFileChange"
                  />
                </div>
                <cropper
                  v-else
                  :key="key"
                  class="cropper"
                  :src="imageData"
                  :auto-zoom="false"
                  :stencil-props="{
                    aspectRatio: 1 / 1,
                  }"
                  fit-area
                  fit
                  @change="change"
                ></cropper>
                <!-- <v-image-input
                  ref="imageEditer"
                  fullHeight
                  fullWidth
                  :imageHeight="800"
                  :imageWidth="800"
                  v-model="imageData"
                  :image-quality="1"
                  clearable
                  image-format="jpeg"
                /> -->
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="cancel">
            {{ $t('generic.cancel') }}
          </v-btn>
          <v-btn color="primary darken-1" flat @click="save">
            {{ $t('generic.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <alert
      v-model="alert.flag"
      :title="alert.title"
      :description="alert.description"
    ></alert>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'

import 'vue-advanced-cropper/dist/style.css'
import VImageInput from 'vuetify-image-input'
import alert from '../Dialogs/Alert'
export default {
  components: {
    [VImageInput.name]: VImageInput,
    alert,
    Cropper,
  },
  props: ['value', 'height', 'width', 'maxWidth', 'image', 'title'],
  data: () => ({
    imageWidth: 0,
    imageData: '',
    croppImage: '',
    alert: {
      title: '',
      description: '',
      flag: false,
    },
    maxW: '600px',
    key: 0,
  }),
  watch: {
    value() {
      if (this.value) {
        this.imageData = this.image
          ? 'data:image/jpeg;base64,' + this.image
          : ''
      }
      if (this.maxWidth) {
        this.maxW = this.maxWidth
      }
      this.key = Math.random()
    },
  },
  methods: {
    onFileChange(e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = () => {
        this.imageData = reader.result
        this.key = Math.random()
      }
      reader.onerror = function (error) {
        console.log('Error: ', error)
      }
    },
    change({ coordinates, canvas }) {
      this.imageWidth = coordinates.width
      this.croppImage = canvas.toDataURL('image/jpeg')
    },
    save() {
      if (this.imageData != null && this.imageData != '') {
        this.$emit('loaded', this.croppImage)
        this.$emit('input', !this.value)
        this.imageData = ''
        // this.$refs.imageEditer.clear()
      } else {
        this.alert.title = 'Error'
        this.alert.description = 'Debes de seleccionar al menos una imagen'
        this.alert.flag = true
      }
    },
    cancel() {
      this.imageWidth = 0
      // this.$refs.imageEditer.clear()
      this.imageData = ''
      this.$emit('input', !this.value)
    },
  },
}
</script>

<style>
.half {
  height: 50vh;
}
</style>
<style scoped>
.cropper {
  height: 600px;
  background: #ddd;
}
.upload {
  position: relative;
  height: 300px;
  width: 100%;
  background-color: #ddd;
  border-radius: 8px;
}
.upload .icon-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.icon-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.upload input {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
</style>
